import vChatBubble from "./v-chat-bubble.vue";
import vChatBubbleFile from "./v-chat-bubble-file.vue";

export default Vue => {
  Vue.component("v-chat-bubble", vChatBubble);
  Vue.component("v-chat-bubble-file", vChatBubbleFile);
};
